<template>
    <transition name="show">
        <div :id='customId' class="modal d-block" tabindex="-1" role="dialog" v-if="show">
            <div :class="'modal-dialog modal-' + size" role="document">
                <div class="modal-content">
                    <div v-if="headerVisible" class="modal-header">
                        <button type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-title">
                        <slot name="title"></slot>
                    </div>
                    <div class="modal-body">
                        <slot name="body"></slot>
                    </div>
                    <div class="modal-footer">
                        <p style="text-align:center;">
                            <slot name="buttons"></slot>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "vModal",
        props: {
            show: Boolean,
            headerVisible: Boolean,
            size: String,
            customId: String,
        },
        methods: {
            close() {
                this.$emit("close");
            }
        },
        watch: {
            show: value => {
                if (value) {
                    document.body.style.overflow = "hidden";
                }
                else {
                    document.body.style.overflow = "unset";
                }
            }
        }
    };
</script>

<style scoped>

    .modal-dialog.modal-md {
        margin: 12% auto;
    }

    .modal-dialog.modal-xlg {
        width: 1300px;
    }

    .modal {
        background: #313541d1;
        overflow-y: auto;
    }

    .close {
        position: absolute;
        right: -35px;
    }

    .modal-footer {
        margin-top: 10px;
    }

    .show-enter-active,
    .show-leave-active {
        transition: all 0.25s;
    }

    .show-enter,
    .show-leave-to {
        transform: translateY(20px);
        opacity: 0;
    }

    .d-block {
        display: block;
    }
</style>


// WEBPACK FOOTER //
// modal.vue?16f141ce